// Copyright 1999-2025. WebPros International GmbH. All rights reserved.

export default {
  Card: {
    select: 'Выбрать',
    titleLinkTooltip: 'Перейти на страницу',
    collapseCardTooltip: 'Свернуть карточку',
    expandCardTooltip: 'Развернуть карточку'
  },
  CardList: {
    loadMore: 'Загрузить больше',
    notFound: 'Не найдено ни одного элемента.',
    toolbarSelect: 'Выбрать',
    viewCards: 'Карточки',
    viewTiles: 'Плитка',
    viewList: 'Список',
    toolbarView: 'Вид'
  },
  ClosingConfirmation: {
    confirm: 'Выйти',
    cancel: 'Вернуться',
    content: 'Вы уверены, что хотите закрыть это окно? Все сделанные вами изменения будут потеряны.'
  },
  Cuttable: {
    showMore: 'Показать все',
    showLess: 'Свернуть'
  },
  Dialog: {
    cancelButton: 'Отменить'
  },
  DrawerProgress: {
    cancelButton: 'Отменить'
  },
  Dropdown: {
    close: 'Закрыть'
  },
  Form: {
    submitButton: 'Сохранить',
    applyButton: 'Применить',
    cancelButton: 'Отменить'
  },
  FormField: {
    clear: 'Очистить',
    remove: 'Удалить',
    addMore: 'Добавить еще'
  },
  FormFieldPassword: {
    improvePassword: 'Чтобы улучшить пароль:',
    passwordTooShort: 'Сделайте пароль длиннее.',
    lettersLowerCase: 'Используйте хотя бы одну букву в нижнем регистре.',
    lettersUpperCase: 'Используйте хотя бы одну букву в верхнем регистре.',
    numbers1: 'Используйте хотя бы одну цифру.',
    numbers3: 'Используйте хотя бы три цифры.',
    specialChar1: 'Используйте хотя бы один специальный символ (например: !, @, #, $, %, ^, &, *, ?, _, ~).',
    specialChar2: 'Используйте хотя бы два специальных символа (например: !, @, #, $, %, ^, &, *, ?, _, ~).',
    comboUpperAndLower: 'Используйте буквы и в верхнем, и в нижнем регистре.',
    comboLettersAndNumbers: 'Используйте и цифры, и буквы.',
    comboLettersNumbersSpecial: 'Используйте цифры, буквы и специальные символы.',
    yourPasswordIsStrong: 'Вы можете сделать его еще более надежным, увеличив его длину.',
    passwordStrength: 'Надежность пароля ― %%strength%%.',
    strengthVeryStrong: 'ОЧЕНЬ НАДЕЖНЫЙ',
    strengthStrong: 'НАДЕЖНЫЙ',
    strengthVeryWeak: 'ОЧЕНЬ НЕНАДЕЖНЫЙ',
    strengthWeak: 'НЕНАДЕЖНЫЙ',
    strengthMedium: 'СРЕДНИЙ',
    hidePassword: 'Скрыть пароль',
    showPassword: 'Показать пароль',
    generateButton: 'Создать',
    copyButtonHint: 'Скопировать пароль',
    copySuccessToast: 'Пароль скопирован',
    generateButtonHint: 'Создать надежный пароль'
  },
  InPlaceEdit: {
    editButtonHint: 'Изменить значение',
    okButtonHint: 'Сохранить изменения',
    cancelButtonHint: 'Отменить изменения'
  },
  InputFile: {
    browseButton: 'Выбрать файл...'
  },
  List: {
    totalRows: 'Всего элементов: %%totalRows%%',
    selectedRows: 'Выбрано элементов: %%selectedRows%% из %%totalRows%%',
    all: 'все',
    allItemsOnPageSelected: 'Выбраны все элементы на странице',
    allItemsSelected: 'Выбраны все элементы',
    selectAllItems: 'Выбрать все элементы',
    selectAllItemsOnPage: 'Выбрать все элементы на странице',
    deselectAll: 'Отменить выбор'
  },
  ListEmptyView: {
    filteredTitle: 'Не удалось найти элементы, соответствующие фильтру',
    emptyTitle: 'Похоже, список пуст',
    filteredDescription: 'Уточните запрос или удалите некоторые критерии из фильтра и повторите попытку.'
  },
  ListOperation: {
    cancelButton: 'Отменить'
  },
  Pagination: {
    totalShort: 'из %%total%%',
    itemsPerPage: 'Элементов на странице',
    all: 'Все',
    total: 'Страница %%current%% из %%total%%'
  },
  ProgressDialog: {
    closeButton: 'Закрыть',
    cancelButton: 'Отменить'
  },
  Select: {
    noOptions: 'Нет опций',
    placeholder: 'Выбрать...'
  },
  SpotPopup: {
    total: '%%current%% из %%total%%'
  },
  Toaster: {
    closeGroup: 'Закрыть группу'
  }
};